/**
 * Created by Fernando Torres on 17/11/2017.
 */

function cloneArray (array) {
  return array.map(item => {
    return Object.assign({}, item)
  })
}

export default {
  model (item, goals, year) {
    let _months = [
      {
        label: 'Enero',
        value: 1,
        sales: 0
      },
      {
        label: 'Febrero',
        value: 2,
        sales: 0
      },
      {
        label: 'Marzo',
        value: 3,
        sales: 0
      },
      {
        label: 'Abril',
        value: 4,
        sales: 0
      },
      {
        label: 'Mayo',
        value: 5,
        sales: 0
      },
      {
        label: 'Junio',
        value: 6,
        sales: 0
      },
      {
        label: 'Julio',
        value: 7,
        sales: 0
      },
      {
        label: 'Agosto',
        value: 8,
        sales: 0
      },
      {
        label: 'Septiembre',
        value: 9,
        sales: 0
      },
      {
        label: 'Octubre',
        value: 10,
        sales: 0
      },
      {
        label: 'Noviembre',
        value: 11,
        sales: 0
      },
      {
        label: 'Diciembre',
        value: 12,
        sales: 0
      }
    ]

    if (item) {
      let $tractorMonths = _months.map(m => {
        let foundGoal = goals.find(g => {
          return g.month === m.value && g.type === 'Tractor'
        })
        return {...m, ...foundGoal}
      })
      let $forrajeroMonths = _months.map(m => {
        let foundGoal = goals.find(g => {
          return g.month === m.value && g.type === 'Equipo Forrajero'
        })
        return {...m, ...foundGoal}
      })
      let $implementoMonths = _months.map(m => {
        let foundGoal = goals.find(g => {
          return g.month === m.value && g.type === 'Implemento'
        })
        return {...m, ...foundGoal}
      })

      return {
        $defaultId: item.id,
        year: year,
        type: 'Tractor',
        periodicity: 'MONTHLY',
        $tractorMonths,
        $forrajeroMonths,
        $implementoMonths
      }
    }
    return {
      $defaultId: null,
      year: null,
      type: null,
      periodicity: 'MONTHLY',
      $tractorMonths: cloneArray(_months),
      $forrajeroMonths: cloneArray(_months),
      $implementoMonths: cloneArray(_months)
    }
  },
  rules () {
    return {
      id: [
        {required: true, message: 'La opcion es requerido'}
      ],
      year: [
        {required: true, message: 'El año es requerido'}
      ],
      type: [
        {required: true, message: 'El típo es requerido'}
      ],
      periodicity: [
        {required: true, message: 'El periodo es requerido'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/goals/goals.model.js